
import { Component, Vue } from 'vue-property-decorator';
import {
  UsersApi,
  User,
  Building,
  ValidationProblemDetails,
  Property,
  PerformoSettings
} from 'performo-api';
import { mapGetters } from 'vuex';
import Location1Picker from '@/components/system/Location1Picker.vue';
import FloorPicker from '@/components/system/FloorPicker.vue';
import Location2Picker from '@/components/system/Location2Picker.vue';
import ScrollIntoView from '@/services/ScrollIntoView';

@Component({
  components: {
    Location1Picker,
    FloorPicker,
    Location2Picker
  },
  computed: mapGetters({
    currentProperty: 'currentProperty',
    currentPropertyId: 'currentPropertyId',
    settings: 'settings'
  })
})
export default class EditMyProfile extends Vue {
  // user profile
  private api = new UsersApi(this.$store.getters.getApiConfiguration);
  private settings!: PerformoSettings;

  private currentProperty!: Property;
  private currentPropertyId!: string;

  validationProblems: ValidationProblemDetails = {};

  get currentUserName(): string {
    return this.user &&
      this.user.contact &&
      this.user.contact.firstName &&
      this.user.contact.lastName
      ? this.user.contact.firstName + ' ' + this.user.contact.lastName
      : this.$store.getters.userDisplayName;
  }

  private user: User = { contact: {} };

  private async mounted() {
    this.user = await this.api.getMyProfile();
  }

  private handleSuccess(update: User) {
    if (update) {
      this.$router.push({ name: 'my-profile' });
    }
  }

  private async handleError(error: ValidationProblemDetails | Response) {
    if (!error) {
      return;
    }

    if (error instanceof Response) {
      error = await error.json();
    }

    this.validationProblems = error;

    // scroll the error div into view on a delay
    setTimeout(() => {
      ScrollIntoView('error-display');
    }, 100);
  }

  private buildingPickedHandler(pickedBuilding: Building) {
    if (this.settings.enableCampuses && this.user.contact) {
      this.user.contact.campus = pickedBuilding.campusName;
    }
  }

  // This function has been directly lifted from \components\orders\requester\create.vue
  get allowProfileEdit(): boolean {
    if (!this.settings.requireProfileForRequests) return true;
    if (!this.settings.requiredProfileAttributes) return true;
    // Check the contact has a value for every required attribute
    const result = this.settings.requiredProfileAttributes.every((attr) => {
      if (!this.user.contact) return false;
      // https://stackoverflow.com/questions/56833469/typescript-error-ts7053-element-implicitly-has-an-any-type/56833507#56833507
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const contact: { [index: string]: any } = this.user.contact;
      return contact[attr] ? true : false;
    });
    return result;
  }

  private updateProfile() {
    if (!(this.user && this.user.contact)) {
      return;
    }
    if (!this.allowProfileEdit) {
      return;
    }
    this.api
      .putMyProfile({
        modifyProfileRequest: {
          loginName: this.user.contact.emailAddress || '',
          lastName: this.user.contact.lastName || '',
          firstName: this.user.contact.firstName || '',
          phone: this.user.contact.phone || '',
          company: this.user.contact.company || '',
          department: this.user.contact.departmentName || '',
          campus: this.user.contact.campus || '',
          building: this.user.contact.location1 || '',
          floor: this.user.contact.floor || '',
          suite: this.user.contact.location2 || ''
        }
      })
      .then(this.handleSuccess)
      .catch(this.handleError);
  }
}
